/*
    API клиент для работы с REST чата текущего сервера.
 */
import { AuthHeaderMiddleware, RefreshTokenMiddleware } from 'api/middlewares';
import { AxiosWrapper, ResponseTransformerMiddleware, RestApiClient } from '@web-chat-core/toolkit/src/api3';

export class AppServerApiClient extends RestApiClient {
    public constructor(serverUrl?: string) {
        super(AxiosWrapper.build(serverUrl || (process.env.REACT_APP_API_URL as string), 'AppServerApiClient'), [
            new AuthHeaderMiddleware(),
            new ResponseTransformerMiddleware(true),
            new RefreshTokenMiddleware(),
        ]);
    }
}
